import { useMutation, useQuery, useQueryClient, type UseQueryResult } from '@tanstack/react-query'
import { apiRequest } from '@/lib/api/client'
import { apiPaths } from '@/lib/api/paths'
import type { TermsStatusResponse } from '@/lib/api/types'

export const termsKey = ['terms', 'status'] as const

export const useTermsStatus = (): UseQueryResult<TermsStatusResponse> =>
  useQuery({
    queryKey: termsKey,
    queryFn: ({ signal }) => apiRequest<TermsStatusResponse>(apiPaths.terms, { signal }),
  })

export const acceptTerms = (version: string): Promise<TermsStatusResponse> =>
  apiRequest<TermsStatusResponse>(apiPaths.termsAcceptance, {
    method: 'POST',
    json: { version },
  })

export const useAcceptTerms = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: acceptTerms,
    onSuccess: (status) => {
      queryClient.setQueryData(termsKey, status)
    },
  })
}

const dismissedKey = 'partner-space-terms-dismissed'

export const wasDismissedThisSession = (version: string): boolean => {
  try {
    return window.sessionStorage.getItem(dismissedKey) === version
  } catch {
    return false
  }
}

export const rememberDismissal = (version: string): void => {
  try {
    window.sessionStorage.setItem(dismissedKey, version)
  } catch {
    return
  }
}

export const useTermsLocked = (): boolean => useTermsStatus().data?.accepted === false
